// hooks
import { useState, useEffect } from "react";

// react-bootstrap
import { Form, Button, Modal, Container } from "react-bootstrap";

// http (services request)
import setDatos from "../../../../../services/setDatos";
import updateDatos from "../../../../../services/updateDatos";

const preguntaAyuda = {
  idAyuda: "",
  nombreAyuda: "",
  descripcionAyuda: "",
  idTipoAyuda: 3,
  activoAyuda: false,
  prioridadAyuda: "",
};

export const AdminPregunta = ({
  caractFiltro,
  idComponente,
  show,
  onHide,
  tituloModal,
  accion,
  listAyudas,
  objectEditarPregunta,
  setLoad,
}) => {
  const [insertPreguntaAyuda, setInsertPreguntaAyuda] = useState(preguntaAyuda);

  const handleChange = ({ target }) => {
    setInsertPreguntaAyuda({
      ...insertPreguntaAyuda,
      [target.name]: target.type === "checkbox" ? target.checked : target.value,
    });
  };

  const handleChangePrioridad = ({ target }) => {
    if (/^-?\d*$/.test(target.value)) {
      if (target.value != "" && target.value < 1) {
        setInsertPreguntaAyuda({
          ...insertPreguntaAyuda,
          [target.name]: target.type === "checkbox" ? target.checked : 100,
        });
      } else {
        setInsertPreguntaAyuda({
          ...insertPreguntaAyuda,
          [target.name]:
            target.type === "checkbox" ? target.checked : target.value,
        });
      }
    }
  };

  const guardarPregunta = async () => {
    const { nombreAyuda, descripcionAyuda } = insertPreguntaAyuda;

    if (!nombreAyuda || !descripcionAyuda) {
      alert("Los campos marcados con * son obligatorios");

      return;
    }

    try {
      setLoad(true);
      if (accion === "Editar") {
        await updateDatos(
          `geomed/ayudas/${insertPreguntaAyuda.idAyuda}`,
          insertPreguntaAyuda
        );
        await listAyudas();
        alert("Registro actualizado exitosamente");
      } else {
        await setDatos("geomed/ayudas", insertPreguntaAyuda);
        await listAyudas();
        alert("Registro guardado exitosamente");
      }
    } catch (error) {
      throw error;
    } finally {
      setLoad(false);
    }

    onHide();
  };

  useEffect(() => {
    if (accion === "Editar" && objectEditarPregunta) {
      setInsertPreguntaAyuda({
        idAyuda: objectEditarPregunta.id_ayuda,
        nombreAyuda: objectEditarPregunta.nombre,
        descripcionAyuda: objectEditarPregunta.descripcion,
        idTipoAyuda: 3,
        activoAyuda: objectEditarPregunta.activo,
        prioridadAyuda: objectEditarPregunta.prioridad,
      });
    } else {
      setInsertPreguntaAyuda(preguntaAyuda);
    }
  }, [objectEditarPregunta]);

  return (
    <Modal show={show} onHide={onHide} size="md" id="modalAdminRegister">
      <Modal.Header closeButton>
        <Modal.Title>{tituloModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="pb-2">
          <Form.Group className="mb-3">
            <Form.Label className="label-forms-admin">
              Pregunta <strong>*</strong>
            </Form.Label>
            <Form.Control
              type="text"
              className="inputs-forms-admin focus-admin-register"
              name={"nombreAyuda"}
              onChange={handleChange}
              value={insertPreguntaAyuda.nombreAyuda}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className="label-forms-admin">
              Respuesta <strong>*</strong>
            </Form.Label>
            <Form.Control
              as="textarea"
              className="inputs-forms-admin focus-admin-register textarea-form-admin"
              name={"descripcionAyuda"}
              onChange={handleChange}
              value={insertPreguntaAyuda.descripcionAyuda}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="label-forms-admin">Prioridad</Form.Label>
            <Form.Control
              type={"text"}
              value={insertPreguntaAyuda.prioridadAyuda}
              className="inputs-forms-admin focus-admin-register"
              name={"prioridadAyuda"}
              min={1}
              maxLength={25}
              onChange={handleChangePrioridad}
            />
          </Form.Group>
          <div className="container-accion-admin">
            <div className="container-checkbox-accion-admin">
              <Form.Check
                type="switch"
                name="activoAyuda"
                onChange={handleChange}
                checked={insertPreguntaAyuda.activoAyuda}
              />
              <Form.Label
                className="label-forms-admin me-2"
                title="Proyecto original"
              >
                Activo
              </Form.Label>
            </div>
            <Button
              className="btn-geomedellin btn-register-admin btn-accion"
              onClick={guardarPregunta}
            >
              Guardar
            </Button>
          </div>
        </Container>
      </Modal.Body>
    </Modal>
  );
};
